import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";
import { getReferenceDataOptions } from "../../../../services/coreServicesCalls";

const sliceName = "appData/citingSearchKind";
const citingSearchKindSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(citingSearchKindThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(citingSearchKindThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(citingSearchKindThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const citingSearchKindThunk = createAsyncThunk(
  `${sliceName}/citingSearchKindThunk`,
  async () => {
    const response = await getReferenceDataOptions("CITING_SEARCH_TYPE")();
    return response;
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.CitingSearchKind);
    },
  },
);

export default citingSearchKindSlice.reducer;
